import React from 'react';
import Header from './Header';
import TestimonialCard from './TestimonialCard';
import CTAButton from './CTAButton';
import TimelineEvent from './TimelineEvent';
import FeaturePoint from './FeaturePoint';
import { CheckCircleIcon, BookOpenIcon, CalendarIcon } from 'lucide-react';
const Advertorial = () => {
  return <div className="max-w-4xl mx-auto bg-white shadow-md font-serif border border-gray-200" data-id="element-76">
      <Header data-id="element-77" />
      <main className="px-4 sm:px-8 py-8" data-id="element-78">
        <div className="prose max-w-none" data-id="element-79">
          <div className="flex items-center text-xs text-gray-500 mb-8 border-b border-gray-200 pb-2" data-id="element-80">
            <div className="flex items-center mr-4" data-id="element-81">
              <BookOpenIcon className="h-3 w-3 mr-1" data-id="element-82" />
              <span data-id="element-83">Health Investigation Series</span>
            </div>
            <div className="flex items-center" data-id="element-84">
              <CalendarIcon className="h-3 w-3 mr-1" data-id="element-85" />
              <span data-id="element-86">
                Updated:{' '}
                {(() => {
                const yesterday = new Date();
                yesterday.setDate(yesterday.getDate() - 1);
                return yesterday.toLocaleDateString('en-US', {
                  month: 'long',
                  day: 'numeric',
                  year: 'numeric'
                });
              })()}
              </span>
            </div>
          </div>
          <p className="text-lg font-medium text-gray-700 mb-6 leading-relaxed border-l-4 border-gray-800 pl-4" data-id="element-87">
            In my three decades of medical practice, I've developed an absolute
            skepticism toward wellness trends that promise health results.
          </p>
          <div className="sm:flex sm:gap-8" data-id="element-88">
            <div className="sm:w-2/3" data-id="element-89">
              <p className="mb-5 text-base" data-id="element-90">
                Throughout the years, I've watched all of the "revolutionary"
                products take people's money while delivering nothing but false
                hope.
              </p>
              <p className="mb-5 text-base" data-id="element-91">
                So when patients began asking about grounding sheets a few years
                ago – those special bedsheets that supposedly connect you to the
                earth's electrical field – I was of course skeptical.
              </p>
              <p className="mb-5 text-base" data-id="element-92">
                My advice was very simple: save your money for proven
                treatments.
              </p>
              <p className="mb-5 text-base" data-id="element-93">
                That position might have remained unchanged if not for a phone
                call from my sister Martha in February 2024.
              </p>
            </div>
            <div className="sm:w-1/3 bg-gray-50 p-5 rounded border border-gray-300 text-sm mt-6 sm:mt-0" data-id="element-94">
              <div className="uppercase text-gray-600 text-xs font-sans tracking-wider mb-3 font-medium border-b border-gray-300 pb-2" data-id="element-95">
                Key Points
              </div>
              <div className="space-y-3" data-id="element-96">
                <FeaturePoint data-id="element-97">
                  Most grounding sheets fail after 2-3 months due to oxidation
                </FeaturePoint>
                <FeaturePoint data-id="element-98">
                  Only one brand survived a full year of testing
                </FeaturePoint>
                <FeaturePoint data-id="element-99">
                  The patented technology prevents conductivity loss
                </FeaturePoint>
                <FeaturePoint data-id="element-100">
                  Real-world testing showed significant sleep improvements
                </FeaturePoint>
              </div>
            </div>
          </div>
          <h2 className="text-2xl font-serif font-bold text-gray-800 mt-12 mb-6 border-b border-gray-800 pb-2 flex items-center" data-id="element-101">
            <span className="inline-block w-4 h-4 bg-gray-800 mr-3" data-id="element-102"></span>
            My Sister's Sleep That Started My Investigation
          </h2>
          <div className="sm:flex items-center mb-6" data-id="element-103">
            <div className="sm:w-1/3 mb-4 sm:mb-0 sm:mr-6" data-id="element-104">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/3dvnTq6PjH596tKqQSVLgR/IMG2.png" alt="Woman with Fitbit reading in bed" className="w-full rounded-lg shadow-md" data-id="element-105" />
            </div>
            <div className="sm:w-2/3" data-id="element-106">
              <p className="mb-5 text-base" data-id="element-107">
                My 68 year old sister, Martha, has dealt with rheumatoid
                arthritis for fifteen years. She's the type who tries everything
                but believes nothing – exactly how I raised her to be.
              </p>
              <p className="mb-5 text-base" data-id="element-108">
                When she called about her new grounding sheet, I was ready with
                my usual "gentle sister reality check" about placebo effects.
              </p>
              <p className="mb-5 text-base" data-id="element-109">
                "I'm sending you my FitBit data, look at it before you lecture
                me," she said.
              </p>
            </div>
          </div>
          <div className="my-8" data-id="element-110">
            <div className="border-l-4 border-yellow-400 pl-5 py-4 bg-yellow-50 rounded-r mb-4" data-id="element-111">
              <p className="font-medium mb-3 text-gray-800" data-id="element-112">
                Before grounding sheet:
              </p>
              <p className="mb-0 text-gray-700" data-id="element-113">
                Sleep score 67-71, deep sleep 42 minutes, waking up 8-12 times
              </p>
            </div>
            <div className="border-l-4 border-green-500 pl-5 py-4 bg-green-50 rounded-r" data-id="element-114">
              <p className="font-medium mb-3 text-gray-800" data-id="element-115">
                Two weeks with sheet:
              </p>
              <p className="mb-0 text-green-700" data-id="element-116">
                Sleep score 84-87, deep sleep 1 hour 48 minutes, waking up 2-3
                times
              </p>
            </div>
          </div>
          <p className="mb-5 text-base" data-id="element-117">
            "Patricia, I slept seven hours straight. That hasn't happened since
            Obama was president."
          </p>
          <p className="mb-5 text-base" data-id="element-118">
            Martha doesn't exaggerate. These weren't subtle changes – they were
            dramatic and sustained.
          </p>
          <h2 className="text-2xl font-serif font-bold text-gray-800 mt-12 mb-6 border-b border-gray-800 pb-2 flex items-center" data-id="element-119">
            <span className="inline-block w-4 h-4 bg-gray-800 mr-3" data-id="element-120"></span>
            The Voltage Test Of My Sister's Sheets
          </h2>
          <div className="sm:flex items-center mb-6" data-id="element-121">
            <div className="sm:w-1/2 mb-4 sm:mb-0 sm:mr-6" data-id="element-122">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/693yUBGTdmCkkbmeDXBSis/IMG3.png" alt="Multimeter testing showing 0.20 volts" className="w-full rounded-lg shadow-md" data-id="element-123" />
            </div>
            <div className="sm:w-1/2" data-id="element-124">
              <p className="mb-5 text-base" data-id="element-125">
                I showed up at Martha's with my equipment to prove this was
                psychological.
              </p>
              <div className="border border-yellow-400 p-5 my-4 bg-yellow-50 rounded" data-id="element-126">
                <p className="mb-3 text-base" data-id="element-127">
                  Her body voltage on a regular mattress:{' '}
                  <span className="font-bold" data-id="element-128">3.8 volts</span> (normal).
                </p>
                <p className="text-base" data-id="element-129">
                  On the grounding sheet:{' '}
                  <span className="font-bold" data-id="element-130">0.20 volts</span>.
                </p>
              </div>
              <p className="mb-5 text-base" data-id="element-131">
                I tested it four more times. The sheet had eliminated 99% of her
                body's electrical charge.
              </p>
              <p className="mb-0 text-base" data-id="element-132">
                This was measurable physics, not psychology.
              </p>
            </div>
          </div>
          <h3 className="text-xl font-serif font-bold text-gray-800 mt-8 mb-4" data-id="element-133">
            Studies I Couldn't Ignore
          </h3>
          <p className="mb-5 text-base" data-id="element-134">That night I found:</p>
          <div className="border-l-4 border-blue-400 pl-5 py-4 bg-blue-50 rounded-r mb-5" data-id="element-135">
            <p className="mb-2 text-base" data-id="element-136">
              <strong data-id="element-137">Journal of Environmental and Public Health:</strong>{' '}
              Grounding reduces blood viscosity almost as effectively as aspirin
            </p>
            <p className="mb-2 text-base" data-id="element-138">
              <strong data-id="element-139">European Biology and Bioelectromagnetics:</strong> 50%
              reduction in inflammatory markers after grounding
            </p>
            <p className="mb-2 text-base" data-id="element-140">
              <strong data-id="element-141">Journal of Inflammation Research:</strong> Normalized
              cortisol patterns and improved sleep architecture
            </p>
            <p className="mb-2 text-base" data-id="element-142">
              <strong data-id="element-143">
                Journal of Alternative and Complementary Medicine:
              </strong>{' '}
              Thermal imaging showing improved circulation
            </p>
          </div>
          <p className="mb-5 text-base" data-id="element-144">
            Twenty-seven peer-reviewed studies, with real science, all written
            in legitimate journals.
          </p>
          <p className="mb-6 text-base" data-id="element-145">
            But what really bothered me: These studies were using real
            laboratory-grade grounding equipment, not something you can get on
            Amazon for 60$.
          </p>
          <p className="mb-5 text-base" data-id="element-146">So I wanted to know:</p>
          <p className="mb-5 text-base" data-id="element-147">
            Were consumer sheets actually providing therapeutic grounding? Or
            was this another case of real science being exploited by garbage
            products?
          </p>
          <p className="mb-6 text-base" data-id="element-148">I had to know.</p>
          <h2 className="text-2xl font-serif font-bold text-gray-800 mt-12 mb-6 border-b border-gray-800 pb-2 flex items-center" data-id="element-149">
            <span className="inline-block w-4 h-4 bg-gray-800 mr-3" data-id="element-150"></span>
            The 6-Month Investigation Begins
          </h2>
          <div className="sm:flex items-center mb-6" data-id="element-151">
            <div className="sm:w-1/2 mb-4 sm:mb-0 sm:mr-6" data-id="element-152">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/dHo5VEQhYCbAaMWfhatkAv/IMG5.png" alt="Boxes of grounding sheets" className="w-full rounded-lg shadow-md" data-id="element-153" />
            </div>
            <div className="sm:w-1/2" data-id="element-154">
              <p className="mb-5 text-base" data-id="element-155">
                I bought 12 grounding sheets ($89-$249) and recruited 12
                volunteers with chronic pain or insomnia, ages 52-74.
              </p>
              <div className="border border-gray-300 p-5 my-4 bg-gray-50 rounded" data-id="element-156">
                <p className="font-medium mb-3 text-gray-800 border-b border-gray-300 pb-2" data-id="element-157">
                  What I measured:
                </p>
                <div className="space-y-3" data-id="element-158">
                  <FeaturePoint data-id="element-159">Body voltage</FeaturePoint>
                  <FeaturePoint data-id="element-160">Sleep quality</FeaturePoint>
                  <FeaturePoint data-id="element-161">Pain levels (daily logs)</FeaturePoint>
                  <FeaturePoint data-id="element-162">
                    Inflammation markers (CRP blood tests)
                  </FeaturePoint>
                  <FeaturePoint data-id="element-163">
                    Sheet conductivity (weekly multimeter tests)
                  </FeaturePoint>
                </div>
              </div>
            </div>
          </div>
          <p className="mb-6 text-base" data-id="element-164">
            The plan was to test everything for six months and let the data
            speak.
          </p>
          <div className="mt-12 mb-10" data-id="element-165">
            <h2 className="text-2xl font-serif font-bold text-gray-800 mb-8 border-b border-gray-800 pb-2 flex items-center" data-id="element-166">
              <span className="inline-block w-4 h-4 bg-gray-800 mr-3" data-id="element-167"></span>
              The Investigation Timeline
            </h2>
            <TimelineEvent title="Week 1: Every Single Sheet Worked" data-id="element-168">
              <p className="mb-4 text-base" data-id="element-169">
                I'm not going to lie – the first week shook me.
              </p>
              <p className="mb-4 text-base" data-id="element-170">
                All twelve sheets worked immediately.
              </p>
              <div className="bg-green-50 border-l-4 border-green-500 p-4 my-4 rounded-r" data-id="element-171">
                <p className="text-base" data-id="element-172">
                  Body voltage dropped 99%, sleep scores improved 15-20 points,
                  pain decreased.
                </p>
                <p className="mt-3 text-base" data-id="element-173">
                  Even my 30-year-old back pain improved.
                </p>
              </div>
              <p className="mb-0 text-base" data-id="element-174">
                By day 7, I had to accept it: Grounding is absolutely real. The
                science is legitimate. The benefits are measurable. To be fair,
                I've absolutely enjoyed the experiment so far.
              </p>
            </TimelineEvent>
            <TimelineEvent title="Month 2: The Decline" data-id="element-175">
              <p className="mb-4 text-base" data-id="element-176">
                Around week 8, the complaints started rolling in:
              </p>
              <p className="mb-4 italic text-gray-700 text-base" data-id="element-177">
                "I'm not sleeping as well as I was" "My hip pain is coming back"
                "Maybe my body got used to it?"
              </p>
              <div className="sm:flex items-center mb-4" data-id="element-178">
                <div className="sm:w-1/2 mb-4 sm:mb-0 sm:mr-6" data-id="element-179">
                  <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/nyq3vwxuQy7oNgMzR466vs/IMG6.png" alt="Failed grounding sheets in laundry basket" className="w-full rounded-lg shadow-md" data-id="element-180" />
                </div>
                <div className="sm:w-1/2" data-id="element-181">
                  <p className="mb-4 text-base" data-id="element-182">
                    I tested everyone's sheets with my multimeter and what I
                    found explained everything:
                  </p>
                  <div className="border border-gray-400 p-4 my-4 bg-gray-50 rounded" data-id="element-183">
                    <p className="mb-3 text-base" data-id="element-184">
                      <strong data-id="element-185">Week 1 readings:</strong> 15-45 ohms (excellent
                      conductivity)
                    </p>
                    <p className="text-base" data-id="element-186">
                      <strong data-id="element-187">Week 8 readings:</strong> 400-2,000+ ohms (failing
                      or dead)
                    </p>
                  </div>
                </div>
              </div>
              <p className="mb-0 text-base" data-id="element-188">
                Five sheets had already died! The volunteers were sleeping on
                expensive regular cotton that no longer conducted anything.
              </p>
              <p className="mb-0 text-base" data-id="element-189">
                The silver threads were oxidizing – reacting with sweat, oxygen,
                and detergent, basically dying off after a month.
              </p>
            </TimelineEvent>
            <TimelineEvent title="Month 3: Mass Failure" data-id="element-190">
              <p className="mb-4 text-base" data-id="element-191">
                Most sheets were dead – over 1,000 ohms (the conducting fully
                stopped).
              </p>
              <p className="mb-0 text-base bg-yellow-100 p-2 inline-block" data-id="element-192">
                I thought my research will be shortly over: Do brands charge
                people hundreds of $$$ for sheets that last twelve weeks? This
                is ridiculous
              </p>
            </TimelineEvent>
            <TimelineEvent title="Month 6: Three Survivors Emerge" data-id="element-193">
              <p className="mb-4 text-base" data-id="element-194">
                After six months of daily use and weekly washing, only three
                sheets were still functioning:
              </p>
              <div className="border border-yellow-400 p-4 my-4 bg-yellow-50 rounded" data-id="element-195">
                <p className="mb-2 text-base" data-id="element-196">
                  <strong data-id="element-197">BareEarth</strong> – 31 ohms (started at 24)
                </p>
                <p className="mb-2 text-base" data-id="element-198">
                  <strong data-id="element-199">GroundingWell</strong> – 67 ohms (started at 35)
                </p>
                <p className="mb-2 text-base" data-id="element-200">
                  <strong data-id="element-201">Earthing.com</strong> – 89 ohms (started at 41)
                </p>
                <p className="mt-4 mb-2 text-base border-t border-yellow-300 pt-2" data-id="element-202">
                  <strong data-id="element-203">Nine sheets:</strong> Completely dead (over 1,000
                  ohms)
                </p>
                <p className="text-base" data-id="element-204">
                  <strong data-id="element-205">Three sheets:</strong> Still grounding effectively
                </p>
              </div>
            </TimelineEvent>
            <TimelineEvent title="Month 12: The Winners" data-id="element-206">
              <p className="mb-4 text-base" data-id="element-207">Month 12 results:</p>
              <div className="border border-yellow-400 p-4 my-4 bg-yellow-50 rounded" data-id="element-208">
                <p className="mb-2 text-base font-bold text-green-700" data-id="element-209">
                  <strong data-id="element-210">BareEarth:</strong> 34 ohms – STILL PERFECT
                </p>
                <p className="mb-2 text-base" data-id="element-211">
                  <strong data-id="element-212">GroundingWell:</strong> 287 ohms (marginal)
                </p>
                <p className="mb-2 text-base" data-id="element-213">
                  <strong data-id="element-214">Earthing.com:</strong> 419 ohms (barely functional)
                </p>
              </div>
              <p className="mb-3 text-base" data-id="element-215">12 months.</p>
              <p className="mb-3 text-base" data-id="element-216">
                After daily use and weekly washing with regular detergent, this
                one sheet was conducting electricity as well as the day I bought
                it.
              </p>
              <p className="mb-0 text-base" data-id="element-217">
                How was this possible? I needed to know
              </p>
            </TimelineEvent>
          </div>
          <h2 className="text-2xl font-serif font-bold text-gray-800 mt-12 mb-6 border-b border-gray-800 pb-2 flex items-center" data-id="element-218">
            <span className="inline-block w-4 h-4 bg-gray-800 mr-3" data-id="element-219"></span>
            Tracking Down the Mystery
          </h2>
          <p className="mb-5 text-base" data-id="element-220">
            BareEarth was a company I'd never heard of.
          </p>
          <p className="mb-5 text-base" data-id="element-221">
            Small operation out of Louisville, Kentucky.
          </p>
          <p className="mb-5 text-base" data-id="element-222">
            Their website was basic, their marketing minimal.
          </p>
          <p className="mb-5 text-base" data-id="element-223">
            Yet their sheets outlasted brands charging twice as much.
          </p>
          <div className="sm:flex items-center mb-6" data-id="element-224">
            <div className="sm:w-1/2 mb-4 sm:mb-0 sm:mr-6" data-id="element-225">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/w6iLitytwoh7neSkFUSQgw/IMG7.png" alt="Email from Patricia to Tom Davidson" className="w-full rounded-lg shadow-md" data-id="element-226" />
            </div>
            <div className="sm:w-1/2" data-id="element-227">
              <p className="mb-5 text-base" data-id="element-228">
                I found the founder's email right on their website and offered
                him a call.
              </p>
              <p className="mb-5 text-base" data-id="element-229">Two hours later, my phone rang.</p>
              <p className="italic text-gray-700 text-base border-l-2 border-gray-400 pl-3" data-id="element-230">
                "Patricia? This is Tom Davidson. I've been waiting three years
                for someone in medicine to ask these questions."
              </p>
            </div>
          </div>
          <h2 className="text-2xl font-serif font-bold text-gray-800 mt-12 mb-6 border-b border-gray-800 pb-2 flex items-center" data-id="element-231">
            <span className="inline-block w-4 h-4 bg-gray-800 mr-3" data-id="element-232"></span>
            The 72-Year Old Retired Engineer That Solved The Problem
          </h2>
          <div className="sm:flex items-center mb-6" data-id="element-233">
            <div className="sm:w-1/2 mb-4 sm:mb-0 sm:mr-6" data-id="element-234">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/gVogzxobjei3H7teaskxTv/IMG8.png" alt="Tom Davidson in his workshop" className="w-full rounded-lg shadow-md" data-id="element-235" />
            </div>
            <div className="sm:w-1/2" data-id="element-236">
              <p className="mb-5 text-base" data-id="element-237">
                Tom Davidson wasn't what I expected. A 72-year-old retired
                electrical engineer from Corning, the company that makes Gorilla
                Glass and fiber optic cables. He said he stumbled into grounding
                through his chronic hip pain.
              </p>
              <div className="border-l-4 border-gray-300 pl-5 py-4 bg-gray-50 rounded-r" data-id="element-238">
                <p className="mb-5 text-base" data-id="element-239">
                  "I loved grounding sheets," he told me. "They helped my pain,
                  improved my sleep. But they kept dying after three months. I
                  was spending $600 a year on sheets that would crap out."
                </p>
                <p className="mb-0 text-base" data-id="element-240">
                  "That's exactly what I found," I said.
                </p>
              </div>
            </div>
          </div>
          <p className="mb-0 text-base bg-yellow-100 p-2 inline-block" data-id="element-241">
            "Right. So I did what engineers do – I solved the problem."
          </p>
          <p className="mb-6 text-base" data-id="element-242">
            His solution came from an unexpected place.
          </p>
          <h2 className="text-2xl font-serif font-bold text-gray-800 mt-12 mb-6 border-b border-gray-800 pb-2 flex items-center" data-id="element-243">
            <span className="inline-block w-4 h-4 bg-gray-800 mr-3" data-id="element-244"></span>
            The "Immortal" Submarine Cables
          </h2>
          <div className="sm:flex items-center mb-6" data-id="element-245">
            <div className="sm:w-1/2 mb-4 sm:mb-0 sm:mr-6" data-id="element-246">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/8YpH7vXuQJk3PcMuCb4bB2/IMG9.webp" alt="Submarine cables on the ocean floor" className="w-full rounded-lg shadow-md" data-id="element-247" />
            </div>
            <div className="sm:w-1/2" data-id="element-248">
              <p className="mb-5 text-base" data-id="element-249">
                "You know those cables at the bottom of the ocean? The ones
                carrying internet data between continents?"
              </p>
              <p className="mb-5 text-base" data-id="element-250">"Vaguely," I admitted.</p>
              <div className="border-l-4 border-blue-300 pl-5 py-4 bg-blue-50 rounded-r" data-id="element-251">
                <p className="mb-5 text-base" data-id="element-252">
                  "They work for 25+ years at the bottom of the ocean and never
                  fail. If we can keep cables working at the bottom of the
                  Pacific for decades, why can't we keep a bed sheet working for
                  more than three months?"
                </p>
              </div>
            </div>
          </div>
          <div className="border-l-4 border-blue-300 pl-5 py-4 my-6 bg-blue-50 rounded-r" data-id="element-253">
            <p className="mb-5 text-base" data-id="element-254">
              "How DO submarine cables stay conductive?" I asked.
            </p>
            <p className="mb-0 text-base" data-id="element-255">
              "Hermetic shielding. Multiple protective layers. The outer layer
              takes all the damage – oxidation, corrosion, degradation – while
              the inner core stays perfect. It's like having sacrificial armor."
            </p>
          </div>
          <h2 className="text-2xl font-serif font-bold text-gray-800 mt-12 mb-6 border-b border-gray-800 pb-2 flex items-center" data-id="element-256">
            <span className="inline-block w-4 h-4 bg-gray-800 mr-3" data-id="element-257"></span>
            The Triple-Shield Threading Innovation
          </h2>
          <div className="sm:flex items-center mb-6" data-id="element-258">
            <div className="sm:w-1/2 mb-4 sm:mb-0 sm:mr-6" data-id="element-259">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/xgP6i5wfhJpSrhNgg4aT5L/IMG10.png" alt="Triple-shield technology diagram showing layers" className="w-full rounded-lg shadow-md" data-id="element-260" />
            </div>
            <div className="sm:w-1/2" data-id="element-261">
              <p className="mb-5 text-base" data-id="element-262">
                Tom explained what makes them different:
              </p>
              <p className="mb-5 text-base" data-id="element-263">
                "We developed Triple-Shield Threading. Each silver thread has
                three distinct layers:
              </p>
              <div className="bg-blue-50 border-l-4 border-blue-500 p-5 rounded-r" data-id="element-264">
                <div className="space-y-3" data-id="element-265">
                  <FeaturePoint data-id="element-266">
                    <strong data-id="element-267">Outer shield</strong> – Takes all the oxidation
                    damage
                  </FeaturePoint>
                  <FeaturePoint data-id="element-268">
                    <strong data-id="element-269">Middle layer</strong> – Secondary protection
                  </FeaturePoint>
                  <FeaturePoint data-id="element-270">
                    <strong data-id="element-271">Conductive core</strong> – Never exposed, stays
                    untouched
                  </FeaturePoint>
                </div>
              </div>
            </div>
          </div>
          <p className="mb-5 text-base" data-id="element-272">
            "Even if the outer layer completely oxidizes, you still have two
            functional layers maintaining conductivity."
          </p>
          <p className="mb-5 text-base" data-id="element-273">
            "Like Russian nesting dolls," I said.
          </p>
          <p className="mb-6 text-base bg-yellow-100 p-2" data-id="element-274">
            "Exactly! The weaving has 47 twists per inch, forming a natural
            spiral that makes it strong and reliable. Even if 70% of the silver
            on the outside gets oxidized, the inner cores stay protected and
            keep the current flowing normally."
          </p>
          <h2 className="text-2xl font-serif font-bold text-gray-800 mt-12 mb-6 border-b border-gray-800 pb-2 flex items-center" data-id="element-275">
            <span className="inline-block w-4 h-4 bg-gray-800 mr-3" data-id="element-276"></span>
            The $388,176 Investment
          </h2>
          <p className="mb-5 text-base" data-id="element-277">
            "This sounds expensive to manufacture," I said.
          </p>
          <div className="sm:flex items-center mb-6" data-id="element-278">
            <div className="sm:w-1/2 mb-4 sm:mb-0 sm:mr-6" data-id="element-279">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/qBYMNDjFnaijkL2KMBjNc2/IMG11.png" alt="Industrial looms for manufacturing triple-shield threading" className="w-full rounded-lg shadow-md" data-id="element-280" />
            </div>
            <div className="sm:w-1/2" data-id="element-281">
              <div className="border-l-4 border-gray-300 pl-5 py-4 bg-gray-50 rounded-r" data-id="element-282">
                <p className="mb-5 text-base" data-id="element-283">
                  Tom laughed. "My ex-colleagues from Corning and I pooled our
                  retirement funds. About $400,000 total. We had to buy looms
                  that could handle triple-layer weaving without destroying the
                  threads, you can't find them on the street!"
                </p>
                <p className="mb-5 text-base" data-id="element-284">
                  "Your wife must have loved that."
                </p>
                <p className="mb-0 text-base" data-id="element-285">
                  "She threatened divorce... But here's the thing – I showed our
                  technology to three major manufacturers, wanna know what they
                  said?"
                </p>
              </div>
            </div>
          </div>
          <p className="mb-5 text-base" data-id="element-286">"What?"</p>
          <p className="mb-6 text-base bg-yellow-100 p-2" data-id="element-287">
            "'Why would we want sheets that last 10 years when customers reorder
            every four months?' They literally told me their business model
            depends on sheets failing."
          </p>
          <h2 className="text-2xl font-serif font-bold text-gray-800 mt-12 mb-6 border-b border-gray-800 pb-2 flex items-center" data-id="element-288">
            <span className="inline-block w-4 h-4 bg-gray-800 mr-3" data-id="element-289"></span>
            And Yes It's Patented
          </h2>
          <p className="mb-5 text-base" data-id="element-290">
            "Can't they just copy your technology?"
          </p>
          <p className="mb-6 text-base bg-yellow-100 p-2" data-id="element-291">
            "Patent #US10,847,293. It took me two years to get approved, but now
            it's mine. They couldn't copy it if they wanted to."
          </p>
          <p className="mb-6 text-base" data-id="element-292">"Which they don't."</p>
          <h2 className="text-2xl font-serif font-bold text-gray-800 mt-12 mb-6 border-b border-gray-800 pb-2 flex items-center" data-id="element-293">
            <span className="inline-block w-4 h-4 bg-gray-800 mr-3" data-id="element-294"></span>
            The Three-Year Test Sheet
          </h2>
          <div className="sm:flex items-center mb-6" data-id="element-295">
            <div className="sm:w-1/2 mb-4 sm:mb-0 sm:mr-6" data-id="element-296">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/caiVyDzajd3WGvCdTW9Fxa/IMG12.png" alt="Tom Davidson holding a grounding sheet and plug" className="w-full rounded-lg shadow-md" data-id="element-297" />
            </div>
            <div className="sm:w-1/2" data-id="element-298">
              <p className="mb-5 text-base" data-id="element-299">
                "Tom, do you have proof this lasts as long as you claim?"
              </p>
              <p className="mb-5 text-base" data-id="element-300">"Hold on."</p>
              <p className="mb-5 text-base" data-id="element-301">
                He returned to the video call with a grounding sheet.
              </p>
              <p className="mb-5 text-base" data-id="element-302">
                "This is our first prototype, we made it three years ago. My
                cousin used it every single night and washed twice weekly."
              </p>
              <p className="mb-5 text-base" data-id="element-303">He connected his multimeter.</p>
              <p className="mb-5 text-base" data-id="element-304">
                The reading:{' '}
                <span className="font-bold text-green-700" data-id="element-305">68 ohms.</span>
              </p>
            </div>
          </div>
          <p className="mb-5 text-base" data-id="element-306">
            After three years of use and roughly 300 washes.
          </p>
          <p className="mb-5 text-base bg-yellow-100 p-2" data-id="element-307">
            My sheets that died after three months read over 2,000 ohms.
          </p>
          <p className="mb-5 text-base" data-id="element-308">"This is incredible," I said.</p>
          <p className="mb-6 text-base" data-id="element-309">
            "This is just proper engineering," he replied.
          </p>
          <h2 className="text-2xl font-serif font-bold text-gray-800 mt-12 mb-6 border-b border-gray-800 pb-2 flex items-center" data-id="element-310">
            <span className="inline-block w-4 h-4 bg-gray-800 mr-3" data-id="element-311"></span>
            Gift From Tom That Won My Heart
          </h2>
          <div className="sm:flex items-center mb-6" data-id="element-312">
            <div className="sm:w-1/2 mb-4 sm:mb-0 sm:mr-6" data-id="element-313">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/h3pU8oFUQasAmK4qhT6W3E/IMG13.png" alt="Email from Tom offering special pricing" className="w-full rounded-lg shadow-md" data-id="element-314" />
            </div>
            <div className="sm:w-1/2" data-id="element-315">
              <p className="mb-5 text-base" data-id="element-316">
                Two weeks after our call, Tom sent an email that surprised me:
              </p>
              <p className="mb-5 text-base" data-id="element-317">I called him immediately.</p>
              <p className="mb-5 text-base" data-id="element-318">
                "Tom, you can't be serious about selling at cost."
              </p>
              <p className="mb-5 text-base bg-yellow-100 p-2" data-id="element-319">
                "Patricia, these companies are stealing from people. If your
                article helps people find sheets that actually work AND saves
                them money? That will be worth more than profit to me. Once
                people test these sheets and see they're still working after a
                year, word spreads. This is marketing, just the honest kind."
              </p>
            </div>
          </div>
          <div className="border-t border-b border-gray-300 py-8 my-12 bg-gray-50" data-id="element-320">
            <h3 className="text-xl font-medium text-gray-800 mb-5 text-center border-b border-gray-300 pb-3" data-id="element-321">
              Get Our Sheets at Production Cost - $109.90
            </h3>
            <CTAButton url="https://offer.bareearthlife.com/groundedsheets/checkout?uid=3062&oid=858&affid=719&sub1=fb" data-id="element-322" />
            <div className="text-xs text-gray-500 mt-3 text-center" data-id="element-323">
              Limited to current inventory of 278 sheets
            </div>
          </div>
          <p className="mb-6 text-base" data-id="element-324">
            I reached out to BareEarth customers to verify longevity:
          </p>
          <div className="my-8" data-id="element-325">
            <TestimonialCard name="Jennifer K." location="Austin, Texas" duration="2 years" testimonial="I used to buy new grounding sheets every 3-4 months. This ONE sheet has outlasted seven previous ones combined. My sleep scores have been consistent for two years straight." data-id="element-326" />
            <TestimonialCard name="Robert M." location="Phoenix" duration="18 months" testimonial="Chronic back pain from construction work. This one bed sheet still works perfectly after 18 months. I know Tom personally, never had a doubt it will be great." data-id="element-327" />
            <TestimonialCard name="Maria S., RN" location="San Diego" duration="14 months" testimonial="As a nurse, I test everything. Other sheets die by month 3. My BareEarth conducts after 14 months of 12-hour shifts and stress sweats just as well as it used to when I bought it." data-id="element-328" />
          </div>
          <h2 className="text-2xl font-serif font-bold text-gray-800 mt-12 mb-6 border-b border-gray-800 pb-2 flex items-center" data-id="element-329">
            <span className="inline-block w-4 h-4 bg-gray-800 mr-3" data-id="element-330"></span>
            The Safety Question Everyone Asks
          </h2>
          <p className="mb-5 text-base" data-id="element-331">
            "But is it safe to be plugged into the wall?"
          </p>
          <p className="mb-5 text-base" data-id="element-332">
            This was everyone's first concern, including mine.
          </p>
          <p className="mb-5 text-base" data-id="element-333">
            Here's what three electrical engineers confirmed:
          </p>
          <div className="border border-yellow-400 p-5 my-8 bg-yellow-50 rounded" data-id="element-334">
            <h3 className="text-lg font-medium mb-4 text-gray-800" data-id="element-335">
              Safety Assessment:
            </h3>
            <p className="mb-4 text-base text-gray-700" data-id="element-336">
              You're ONLY connected to the ground pin – the round hole at the
              bottom of your outlet. This pin carries ZERO electricity. Its
              entire purpose is safety discharge.
            </p>
            <p className="text-gray-700 mb-5 text-base" data-id="element-337">
              It's literally the same as standing barefoot on wet grass, just
              consistent and measurable.
            </p>
            <p className="text-gray-800 font-medium mb-3" data-id="element-338">
              In 12 months of testing with multiple users:
            </p>
            <div className="space-y-2" data-id="element-339">
              <div className="flex items-center text-gray-700" data-id="element-340">
                <CheckCircleIcon className="h-5 w-5 text-green-600 mr-2 flex-shrink-0" data-id="element-341" />
                <span className="text-base" data-id="element-342">Zero electrical incidents</span>
              </div>
              <div className="flex items-center text-gray-700" data-id="element-343">
                <CheckCircleIcon className="h-5 w-5 text-green-600 mr-2 flex-shrink-0" data-id="element-344" />
                <span className="text-base" data-id="element-345">Zero shocks</span>
              </div>
              <div className="flex items-center text-gray-700" data-id="element-346">
                <CheckCircleIcon className="h-5 w-5 text-green-600 mr-2 flex-shrink-0" data-id="element-347" />
                <span className="text-base" data-id="element-348">Zero safety issues</span>
              </div>
            </div>
          </div>
          <p className="mb-6 text-base" data-id="element-349">
            The only "shocks" came from static buildup on the dead sheets –
            because they weren't actually grounding anything.
          </p>
          <h2 className="text-2xl font-serif font-bold text-gray-800 mt-12 mb-6 border-b border-gray-800 pb-2 flex items-center" data-id="element-350">
            <span className="inline-block w-4 h-4 bg-gray-800 mr-3" data-id="element-351"></span>
            My Professional Verdict
          </h2>
          <p className="mb-5 text-base" data-id="element-352">
            After 12 months of investigation, here's the truth:
          </p>
          <div className="space-y-3 mb-8 border border-yellow-400 p-5 bg-yellow-50 rounded" data-id="element-353">
            <FeaturePoint data-id="element-354">
              Grounding is scientifically legitimate. The studies are real, the
              benefits measurable.
            </FeaturePoint>
            <FeaturePoint data-id="element-355">
              Most grounding sheets are designed to fail. They die in 2-3 months
              from oxidation.
            </FeaturePoint>
            <FeaturePoint data-id="element-356">
              Only ONE brand survived a full year of testing while maintaining
              perfect conductivity.
            </FeaturePoint>
            <FeaturePoint data-id="element-357">
              The technology exists to make sheets that last. But only one
              company is using it.
            </FeaturePoint>
            <FeaturePoint data-id="element-358">
              The industry profits from failure. Repeat customers every 3 months
              is their business model.
            </FeaturePoint>
          </div>
          <h2 className="text-2xl font-serif font-bold text-gray-800 mt-12 mb-6 border-b border-gray-800 pb-2 flex items-center" data-id="element-359">
            <span className="inline-block w-4 h-4 bg-gray-800 mr-3" data-id="element-360"></span>
            The Opportunity Tom Created
          </h2>
          <div className="border border-gray-400 p-5 my-8 bg-gray-50 rounded" data-id="element-361">
            <p className="font-medium mb-4 text-gray-800" data-id="element-362">
              Tom's offer for readers of this investigation:
            </p>
            <div className="space-y-2" data-id="element-363">
              <div className="flex justify-between" data-id="element-364">
                <span className="text-base" data-id="element-365">Regular price:</span>
                <span className="text-base font-medium" data-id="element-366">$219.98</span>
              </div>
              <div className="flex justify-between" data-id="element-367">
                <span className="text-base" data-id="element-368">Investigation reader price:</span>
                <span className="font-bold text-green-700" data-id="element-369">$109.99</span>
              </div>
              <div className="flex justify-between" data-id="element-370">
                <span className="text-base" data-id="element-371">Valid for:</span>
                <span className="text-base" data-id="element-372">72 hours after publication</span>
              </div>
              <div className="flex justify-between" data-id="element-373">
                <span className="text-base" data-id="element-374">Available inventory:</span>
                <span className="text-base" data-id="element-375">Approximately 200 sheets</span>
              </div>
            </div>
          </div>
          <h2 className="text-2xl font-serif font-bold text-gray-800 mt-12 mb-6 border-b border-gray-800 pb-2 flex items-center" data-id="element-376">
            <span className="inline-block w-4 h-4 bg-gray-800 mr-3" data-id="element-377"></span>
            My Personal Investment
          </h2>
          <p className="mb-5 text-base" data-id="element-378">
            At 58, with three decades of medical experience, I've learned to be
            selective about what I endorse.
          </p>
          <p className="mb-5 text-base" data-id="element-379">
            I now own five BareEarth sheets – one for each bedroom plus two
            spares.
          </p>
          <p className="mb-5 text-base" data-id="element-380">
            Not because Tom gave them to me (I insisted on paying full price).
          </p>
          <p className="mb-5 text-base" data-id="element-381">
            But because after 12 months of rigorous testing, they're the only
            sheets still working.
          </p>
          <p className="mb-6 text-base bg-yellow-100 p-2" data-id="element-382">
            My sleep scores stay consistent. My back pain stays manageable. My
            inflammation markers stay reduced.
          </p>
          <p className="mb-6 text-base" data-id="element-383">
            All from sheets that actually keep grounding, month after month,
            year after year.
          </p>
          <h2 className="text-2xl font-serif font-bold text-gray-800 mt-12 mb-6 border-b border-gray-800 pb-2 flex items-center" data-id="element-384">
            <span className="inline-block w-4 h-4 bg-gray-800 mr-3" data-id="element-385"></span>
            How to Access Tom's Offer
          </h2>
          <p className="mb-5 text-base" data-id="element-386">
            Tom created a special page exclusively for readers of this
            investigation:
          </p>
          <div className="text-center my-10" data-id="element-387">
            <div className="max-w-md mx-auto" data-id="element-388">
              <CTAButton data-id="element-389" />
            </div>
          </div>
          <p className="mb-5 text-base bg-yellow-100 p-2" data-id="element-390">
            The offer expires 72 hours after this article publishes. Current
            inventory is approximately 200 sheets before the next production run
            in 3-4 weeks.
          </p>
          <p className="mb-6 text-base" data-id="element-391">
            Every order includes a multimeter. Tom wants you to test it
            yourself.
          </p>
          <p className="mb-6 text-base" data-id="element-392">
            That's the confidence that comes from actual engineering, not
            marketing claims.
          </p>
          <h2 className="text-2xl font-serif font-bold text-gray-800 mt-12 mb-6 border-b border-gray-800 pb-2 flex items-center" data-id="element-393">
            <span className="inline-block w-4 h-4 bg-gray-800 mr-3" data-id="element-394"></span>A
            Final Thought from Tom
          </h2>
          <p className="mb-5 text-base" data-id="element-395">
            When I asked Tom why he does this at 72, his answer stayed with me:
          </p>
          <blockquote className="font-serif italic border-l-3 border-gray-400 pl-5 py-4 my-8 bg-yellow-50 rounded-r text-gray-700" data-id="element-396">
            "I found something that genuinely helped my pain after decades of
            suffering. Then I discovered an entire industry scamming people with
            products designed to fail. I had the knowledge to fix it. What kind
            of engineer – what kind of person – would I be if I didn't?"
            <div className="text-sm mt-3 text-gray-600 not-italic" data-id="element-397">
              — Tom Davidson, Electrical Engineer
            </div>
          </blockquote>
          <div className="border-t border-gray-200 mt-12 pt-6" data-id="element-398">
            <div className="flex items-center mb-4" data-id="element-399">
              <div className="w-8 h-8 overflow-hidden rounded-full flex-shrink-0 mr-2 border border-gray-300" data-id="element-400">
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/5V1KLd9diP6p4Lsag55oX2/YYkJmGMhE_ELwA2hWH_Ii.jpg" alt="Patricia Chen" className="w-full h-full object-cover" data-id="element-401" />
              </div>
              <p className="text-sm text-gray-800" data-id="element-402">
                <span className="font-medium" data-id="element-403">Patricia Chen, RN, MSN.</span>{' '}
                This investigation was entirely self-funded with no compensation
                from any mentioned company.
              </p>
            </div>
            <p className="text-sm text-gray-700 mb-3 bg-yellow-100 p-2 border-l-2 border-yellow-500" data-id="element-404">
              <strong data-id="element-405">P.S.</strong> – If you currently own a grounding sheet,
              test it with a multimeter today. If it reads over 500 ohms, it's
              dead. That's why your benefits disappeared – not because your body
              "adapted," but because your sheet stopped working.
            </p>
            <p className="text-sm text-gray-700 bg-yellow-100 p-2 border-l-2 border-yellow-500" data-id="element-406">
              <strong data-id="element-407">P.P.S.</strong> – Tom Davidson personally responds to
              every email. When's the last time you could reach a founder
              directly? That tells you everything about the integrity behind
              this product.
            </p>
          </div>
        </div>
      </main>
      <div className="px-4 sm:px-8 py-6 border-t border-gray-200 bg-gray-50" data-id="element-408">
        <div className="max-w-4xl mx-auto text-[10px] text-gray-400 leading-tight" data-id="element-409">
          <p className="mb-2" data-id="element-410">
            These statements have not been evaluated by the Food and Drug
            Administration. This product is not intended to diagnose, treat,
            cure, or prevent any disease.
          </p>
          <p className="mb-2" data-id="element-411">
            Individual results may vary. Results described in testimonials and
            case studies are not typical and your experience may differ.
          </p>
          <p className="mb-2" data-id="element-412">
            This article is for informational purposes only and is not intended
            as a substitute for advice from your physician or other healthcare
            professional.
          </p>
          <p className="mb-2" data-id="element-413">
            Any references to scientific studies, researchers, or institutions
            are for informational context only and do not imply endorsement of
            this product.
          </p>
          <p data-id="element-414">
            This is a paid advertisement for BareEarth and is not an actual news
            article or blog. The story and opinions expressed here are for
            promotional purposes only.
          </p>
        </div>
      </div>
      <div className="bg-black h-3 w-full" data-id="element-415"></div>
    </div>;
};
export default Advertorial;